export default __webpack_public_path__ + "static/media/lb.cab0f9e2.jpg";